import PropTypes from 'prop-types';
import Modal from '../../../../../components/Modal/index';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import '../../../style/myContent.css';
import { useNavigate } from 'react-router';

const CreateFlashcardSetModel = ({
  isOpen,
  onClose,
  showFlashcardOptions,
  onSave
}) => {
  const [name, setName] = useState('');
  const navigate = useNavigate();

  return(
    <Modal isOpen={isOpen} titleName={'Create Flash Card Set'} onClose={onClose} contentWidth="655px">
      <div>
        <label className='form-label fw-normal'>Set Name</label>
        <div className='d-flex align-items-center gap-3'>
          <input
            onChange={(e) => setName(e.target.value)}
            type="text"
            className='form-control col'
          />
          <button
            onClick={() => onSave(name)}
            className='btn btn-castleRed btn-width' disabled={!name.trim().length > 0 || name.length > 50}>
            Save
          </button>
        </div>
        {name.length > 50 &&
          <div className="text-danger">Set Name has exceeded a limit of 50 characters!</div>
        }
      </div>
      {showFlashcardOptions && 
      <>
        <div className='my-3 d-flex align-items-center divider-line'>
          <div/>
          <span className='mx-2 fs-14'>OR</span>
          <div/>
        </div>
        <div>
          <h2 className='fw-500'>Add Flash Card</h2>
          <p>Add flash card first, then create a new flash card set.</p>
          <Row className='g-3'>
            <Col className='col-12'>
              <button
                className='w-100 p-2 btn-questionset text-start cursor-pointer' onClick={()=> navigate('flashcards/addflashcard')}
              >
                <div className='align-items-center d-flex'>
                  <div className='align-items-center blue-icon d-flex fs-5 justify-content-center'><FontAwesomeIcon icon={faPlus} /></div>
                  <p className='m-0'>Add Flash Card</p>
                </div>
              </button>
            </Col>
          </Row>
        </div>
      </>
      }
    </Modal>
  );
};

CreateFlashcardSetModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  showFlashcardOptions: PropTypes.bool,
  onSave: PropTypes.func
};

export default CreateFlashcardSetModel;
  
